import {useState} from 'react';
import {useNavigate} from 'react-router-dom';

import Alert from '@mui/material/Alert';
import Button from "@mui/material/Button";
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';

import * as formValidations from '../../helpers/validations';
import CustomTextField from '../common/CustomTextField';
import './CompleteResetPasswordForm.scss';


const validations = (blurred) => ({
  password: formValidations.password,
  email: formValidations.email,
});

const ResetPasswordForm = props => {
  const {success} = props;
  const navigate = useNavigate();
  const [email, setEmail] = useState(props.defaultEmail || '');
  const [password, setPassword] = useState('');
  const formValues = {email, password};
  const [blurred, setBlurred] = useState([]);
  const formIsInvalid = Object.keys(validations).reduce((acc, k) => (
    validations[k](formValues[k]) ? acc : true
  ), false);
  return (
    <Box className='CompleteResetPasswordForm'>
        <Container maxWidth='sm'>
          <Stack spacing={2}>
            {props.success
              ? <Alert severity='success'>
                Your password was reset!
              </Alert>
              : null
            }

            <CustomTextField
              id='emailInput'
              placeholder='jane.smith@gmail.com'
              helperText='Please enter your email address to verify your identity.'
              variant='outlined'
              label='Email'
              required
              type='email'
              error={blurred.includes('email') && !formValidations.email(email)}
              onChange={e => setEmail(e.target.value)}
              onBlur={() => setBlurred([...blurred, 'email'])}
            />
            <CustomTextField
              id='passwordInput'
              helperText='Password must be at least 8 characters and contain an uppercase letter, a lowercase letter, and a number.'
              variant='outlined'
              label='New Password'
              required
              type='password'
              error={blurred.includes('password') && !formValidations.password(password)}
              onChange={e => setPassword(e.target.value)}
              onBlur={() => setBlurred([...blurred, 'password'])}
            />

            <Button
              size='medium'
              variant='primaryGradient'
              disabled={formIsInvalid || success|| props.isSubmitting}
              onClick={() => props.onSubmit(formValues)}
            >
              Reset Password
            </Button>

            <Button
              size='medium'
              variant='primaryOutline'
              onClick={() => navigate('/login')}
            >
              Login
            </Button>
          </Stack>
        </Container>
    </Box>
  );
};

export default ResetPasswordForm;
